import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useWebSocketEvent } from '../context/WebSocketContext';

export const useIncomingVideoCall = () => {
	const { user } = useSelector(state => state.auth);
	const [incomingCall, setIncomingCall] = useState(null);

	useWebSocketEvent('INCOMING_VIDEO_CALL', useCallback(payload => {
		console.log('Incoming Call Received:', payload);
		setIncomingCall(payload);
	}, []));

	const acceptCall = () => {
		if (!incomingCall) return;
		const { roomName, imei } = incomingCall;

		const url = `/meeting?room=${roomName}&watchId=${imei}&nick=${user?.name || 'Admin'}&type=smartWatch`;
		window.open(url, '_blank', 'noopener,noreferrer');

		setIncomingCall(null);
	};

	const declineCall = () => {
		setIncomingCall(null);
	};

	return {
		incomingCall,
		acceptCall,
		declineCall,
	};
};